import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["innerHTML", "data-ctype"]
const _hoisted_2 = ["innerHTML", "data-ctype", "data-index"]
const _hoisted_3 = ["innerHTML", "data-ctype", "data-index"]
const _hoisted_4 = ["innerHTML", "data-ctype", "data-index"]
const _hoisted_5 = { key: 7 }

export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button")
  const _component_Img = _resolveComponent("Img")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('bubble') + ' ' +
	(((_ctx.isBubbleHasButton !== null && _ctx.isBubbleHasButton) || (_ctx.isBubbleHasLinkButton !== null && _ctx.isBubbleHasLinkButton)) ? _ctx.getClass('fill_available') : '')),
    ref: "containerRef"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.components, (component, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (component.type=='text' && _ctx.getDisplayContent(component))
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              innerHTML: _ctx.formatMessageContent(_ctx.decodeTags(_ctx.getDisplayContent(component))),
              "data-ctype": component.type
            }, null, 8 /* PROPS */, _hoisted_1))
          : (component.type=='html' && _ctx.getDisplayContent(component))
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                innerHTML: _ctx.formatMessageContent(_ctx.getDisplayContent(component)),
                "data-ctype": component.type,
                "data-index": index
              }, null, 8 /* PROPS */, _hoisted_2))
            : (component.type=='htmlblock' && _ctx.getDisplayContent(component))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  innerHTML: _ctx.formatMessageContent(_ctx.getDisplayContent(component)),
                  "data-ctype": component.type,
                  "data-index": index
                }, null, 8 /* PROPS */, _hoisted_3))
              : (component.type=='markdown' && _ctx.getDisplayContent(component))
                ? (_openBlock(), _createElementBlock("p", {
                    key: 3,
                    innerHTML: _ctx.formatMessageContent(_ctx.marked(_ctx.getDisplayContent(component))),
                    "data-ctype": component.type,
                    "data-index": index
                  }, null, 8 /* PROPS */, _hoisted_4))
                : (component.type=='button' || component.type=='link')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 4,
                      component: component,
                      messageContentsettings: _ctx.messageContentsettings,
                      messageId: _ctx.messageId
                    }, null, 8 /* PROPS */, ["component", "messageContentsettings", "messageId"]))
                  : (component.type=='image')
                    ? (_openBlock(), _createBlock(_component_Img, {
                        key: 5,
                        component: component,
                        structureSettings: _ctx.structureSettings,
                        messageId: _ctx.messageId
                      }, null, 8 /* PROPS */, ["component", "structureSettings", "messageId"]))
                    : (component.type=='line')
                      ? (_openBlock(), _createElementBlock("hr", {
                          key: 6,
                          class: _normalizeClass(_ctx.getClass('hr-divider'))
                        }, null, 2 /* CLASS */))
                      : (component.type=='break')
                        ? (_openBlock(), _createElementBlock("br", _hoisted_5))
                        : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
    }), 256 /* UNKEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}